<div class="product-info">
  <div class="product-info__name" [innerText]="product.name"></div>
  <div class="product-info__price" [innerText]="product.price | currency"></div>
  <div class="product-info__fulfillment">
    Fulfillment by {{ product.fulfillment }}
  </div>
</div>
